var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56853_18737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 6H15.6V2.4C15.6 1.08 14.52 0 13.2 0H10.8C9.48 0 8.4 1.08 8.4 2.4V6H2.4C1.08 6 0 7.08 0 8.4V21.6C0 22.92 1.08 24 2.4 24H21.6C22.92 24 24 22.92 24 21.6V8.4C24 7.08 22.92 6 21.6 6ZM8.4 12C9.396 12 10.2 12.804 10.2 13.8C10.2 14.796 9.396 15.6 8.4 15.6C7.404 15.6 6.6 14.796 6.6 13.8C6.6 12.804 7.404 12 8.4 12ZM12 19.2H4.8V18.3C4.8 17.1 7.2 16.5 8.4 16.5C9.6 16.5 12 17.1 12 18.3V19.2ZM13.2 8.4H10.8V2.4H13.2V8.4ZM19.2 17.4H14.4V15.6H19.2V17.4ZM19.2 13.8H14.4V12H19.2V13.8Z",
    fill: "#0F2C54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56853_18737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericStaff);
export default __webpack_public_path__ + "static/media/generic-staff.e6fbb5fab99b3603d9f1c4ea89af70af.svg";
export { ForwardRef as ReactComponent };